"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_1 = require("@alifd/next");
var LoadJs = require("loadjs");
var Cookie = require("js-cookie");
var task_1 = require("@alife/task");
/**
 * @param param 加载的bundle的唯一标识，格式：大厅id_设备类型_设备型号
 */
function getIsvJsBundleByType(param) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, type, device, targetJs;
        return __generator(this, function (_b) {
            console.log("===paraps==", param);
            try {
                if (!param) {
                    throw new Error("参数格式错误，应遵循: 大厅id_设备类型_设备型号");
                }
                _a = task_1.Util.decode(param), type = _a.type, device = _a.device;
                if (!type) {
                    throw new Error("没有传入设备类型");
                }
                if (!device) {
                    throw new Error("没有传入设备型号");
                }
                targetJs = Cookie.get(type) || "";
                if (!targetJs) {
                    next_1.Message.error("设备驱动js未找到");
                    return [2 /*return*/, ""];
                }
                //
                if (!targetJs.endsWith("js")) {
                    return [2 /*return*/, targetJs + "/index.js"];
                }
                return [2 /*return*/, targetJs];
            }
            catch (error) {
                throw error;
            }
            return [2 /*return*/];
        });
    });
}
exports.getIsvJsBundleByType = getIsvJsBundleByType;
function requireModule(moduleName) {
    if (!moduleName) {
        return Promise.reject("module name不能为空");
    }
    return new Promise(function (resolve, reject) {
        LoadJs(moduleName, function () {
            if (window.PortalModule) {
                console.log("驱动加载成功");
                resolve(window.PortalModule.default);
            }
            else {
                console.error("驱动加载失败，没找到window.PortalModule");
                reject("无PortalModule");
            }
        });
    });
}
exports.requireModule = requireModule;
/**
 * @param unionParam 加载的bundle的唯一标识，格式：大厅id_设备类型_设备型号
 */
function getIsvModule(unionParam) {
    return __awaiter(this, void 0, void 0, function () {
        var bundles, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getIsvJsBundleByType(unionParam)];
                case 1:
                    bundles = _a.sent();
                    return [4 /*yield*/, requireModule(bundles)];
                case 2:
                    data = _a.sent();
                    // const data: any = await requireModule('//gov-bus.oss-cn-hangzhou.aliyuncs.com/gov-open/zj/200601102/v2.0.1/index.js');
                    // const data: any = await requireModule('//gov-bus.oss-cn-hangzhou.aliyuncs.com/gov-open/zj/200601102/v2.0.5/index.js');
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _a.sent();
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getIsvModule = getIsvModule;
